/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { Component } from 'react';
import { Grid, Row, Col, Form, FormGroup, ControlLabel, FormControl, Button } from 'react-bootstrap';
import 'react-select/dist/react-select.css';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Card from 'Admin/components/Card/Card.jsx';
import { uploadPdfAction } from 'Admin/actions/link';
import { uploadFileAction } from 'Admin/actions/master';
import { addAttachmentAction } from 'Admin/actions/attachment';

let Validator = require('validatorjs');
let formArr = {}
let rules = {
    name: 'required',
    file: 'required',
};
let mess = {
    required: 'This field is required',
};
let validation = [];
validation = new Validator({}, rules, mess);
validation.passes();
validation.fails();

class AddAttachment extends Component {

    constructor(props) {
        super(props);

        this.state = {
            cardHidden: true,
            isLoading: false,
            formArr: [],
            nameError: null,
            fileError: null,
            formData: {
                name: "",
                file: "",
                files: []
            },
            isLogin: true,
            showProcessing: false,
            limitForm: {},
        }
    }


    componentWillReceiveProps(nextProps) {


        if (nextProps.isAddAttachmentError !== this.props.isAddAttachmentError) {
            if (nextProps.msg.errors) {
                nextProps.msg.errors.map((key, i) => {
                    this.setState({ [(key.param) + "Error"]: <small className="text-danger">{key.msg}</small> })
                });
            }
        }

        if (nextProps.isUploadPdf !== this.props.isUploadPdf) {

            let field = this.state.formData;
            field["files"] = nextProps.uploadPdf.file_name;
            this.setState({ formData: field });
        }

        if (nextProps.isUploadFile !== this.props.isUploadFile) {
            let uploaded_file = this.state.uploaded_file;
            let field = this.state.formData;
            field[uploaded_file] = nextProps.uploadFile.file_name;
            this.setState({ formData: field });
        }

        if (nextProps.isUploadFileError !== this.props.isUploadFileError) {
            if (nextProps.uploadFile.errors) {
                let uploaded_file = this.state.uploaded_file;
                nextProps.uploadFile.errors.map((key, i) => {
                    this.setState({ [uploaded_file + "Error"]: key.msg });
                });
            }
        }

        // if(nextProps.isUploadPdfError !== this.props.isUploadPdfError){
        //   if(nextProps.uploadPdf.errors){
        //     let uploaded_file = this.state.uploaded_file;
        //       nextProps.uploadPdf.errors.map((key,i) => {
        //           this.setState({[uploaded_file+"Error"]:key.msg})
        //       });
        //   }
        // }

        if (nextProps.addAttachmentAction && nextProps.isAddAttachment) {
            this.props.handleClick('success', nextProps.msg)
            this.props.history.push('/admin/attachment-list');
        }
    }

    handleChange(e, type) {
        e.preventDefault();
        let field = this.state.formData;
        field[e.target.name] = e.target.value;
        this.setState({ formData: field });
    };


    fileChangedHandler(event, elename) {
        event.preventDefault();
        this.setState({ uploaded_file: elename });
        let reader = new FileReader();
        let file = event.target.files[0];
        if (file.type == 'application/pdf') {
            this.props.uploadPdfAction(file);
            this.props.uploadFileAction(file);
            reader.readAsDataURL(file);
            this.setState({ fileError: null })
        } else {
            this.setState({ fileError: 'Pdf file is required.' })
        }

    }

    allValidate(check) {
        if (!check) {
            formArr = []
            Object.keys(rules).forEach(function (key) {
                formArr[key] = "TT";
            });
            this.setState({
                formArr
            });
        }
        if (validation.passes()) {
            return 1;
        }
    }

    addAttachment(evt) {
        this.setState({ isLoading: true });
        evt.preventDefault();
        const _this = this;
        if (this.allValidate(false)) {
            let field = this.state.formData;

            this.setState({ formData: field });
            _this.setState({ showProcessing: true });
            _this.props.addAttachmentAction(field);
        }
        //validation.errors()
        setTimeout(() => {
            // Once the action is complete, enable the button again
            this.setState({ isLoading: false });
        }, 100);
        this.props.onClickAction()
            .then(() => {
                // After the action is completed, reset the loading state to false
                this.setState({ isLoading: false });
            })
            .catch(() => {
                // Handle any errors and reset loading state
                this.setState({ isLoading: false });
            });
    }

    goBackFun(e) {
        this.props.history.replace(sessionStorage.getItem("prvUrl"))
    }

    render() {

        validation = new Validator(this.state.formData, rules, mess);
        validation.passes();
        validation.fails();
        const { isLoading } = this.state;

        return (
            <div className="main-content" style={{ padding: '15px 0px' }}>
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                title={<legend className="line-removes">
                                    <Button className="go-back-btn-1" bsStyle="info" onClick={(e) => { this.goBackFun(e) }}>Back</Button>
                                </legend>}
                                content={
                                    <Form horizontal>

                                        <FormGroup>
                                            <Col componentClass={ControlLabel} sm={2} smOffset={2}>
                                                Name <span className="star">*</span>
                                            </Col>
                                            <Col sm={6}>

                                                <FormControl type="text" name="name" id="name" placeholder="Name" onChange={e => { this.handleChange(e); }} />
                                                <span className="errorMsg">
                                                    {this.state.nameError}
                                                    {this.state.formArr.name && validation.errors.first('name')}</span>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup>
                                            <Col componentClass={ControlLabel} sm={2} smOffset={2}>
                                                File <span className="star">*</span>
                                            </Col>
                                            <Col sm={6}>
                                                <input type="file" name="file" onChange={e => { this.fileChangedHandler(e, "file") }}></input>
                                                <small>Only PDF file allow.</small>
                                                <span className="errorMsg">
                                                    {this.state.fileError}
                                                    {this.state.formArr.file && validation.errors.first('file')}</span>
                                            </Col>
                                        </FormGroup>

                                        <FormGroup>
                                            <Col componentClass={ControlLabel} sm={2} smOffset={2}></Col>
                                            <Col sm={6}>
                                                <button
                                                    type="button"
                                                    onClick={this.addAttachment.bind(this)}
                                                    className="btn-fill btn-wd btn btn-primary"
                                                    disabled={isLoading || this.props.disabled}
                                                >
                                                    {isLoading ? (
                                                        <span class="fa fa-spinner fa-spin spinner-btn" role="status" aria-hidden="true"></span>
                                                    ) : (
                                                        this.props.children
                                                    )}
                                                    Save</button>&nbsp;
                                            </Col>
                                        </FormGroup>
                                    </Form>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

function mapStateToProps(state) {

    return {
        msg: state.attachment.message,

        AddAttachment: state.attachment.AddAttachment,
        isAddAttachment: state.attachment.isAddAttachment,
        isAddAttachmentError: state.attachment.isAddAttachmentError,

        isUploadFile: state.master.isUploadFile,
        isUploadFileError: state.master.isUploadFileError,
        uploadFile: state.master.uploadFile,

        isUploadPdf: state.link.isUploadPdf,
        isUploadPdfError: state.link.isUploadPdfError,
        uploadPdf: state.link.uploadPdf,

    }
}
export default withRouter(connect(mapStateToProps, { addAttachmentAction, uploadFileAction, uploadPdfAction })(AddAttachment));
